export default __webpack_public_path__ + "static/media/aw.a466b0d7.jpg";